import { render, staticRenderFns } from "./user-add-or-update-basic.vue?vue&type=template&id=7113b764&"
import script from "./user-add-or-update-basic.vue?vue&type=script&lang=js&"
export * from "./user-add-or-update-basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports